import axiosInstance from "../axiosInstance";
const WORKERS = `/workers/`;

export const customMethod = (request, method, data) =>
  axiosInstance[request](WORKERS + method, data);
